<template>
  <v-data-table
    :headers="headers"
    :items="arquivos"
    disable-pagination
    hide-default-footer
    item-key="id"
    class="text-no-wrap"
    dense
  >
    <template v-slot:item.nomeArquivo="{ item }">
      {{ item.nomeArquivo || '-'}}
      <v-btn
        icon
        color="primary"
        @click="() => getDocument({ doc_id: item.docId, nome: item.nomeArquivo })"
      >
        <v-icon x-small>fas fa-download</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.valorInformado="{ item }">
      R$ {{ item.valorInformado | formatPrice }}
    </template>

    <template v-slot:item.valorProcessado="{ item }">
      R$ {{ item.valorProcessado | formatPrice }}
    </template>

    <template v-slot:item.valorPago="{ item }">
      R$ {{ item.valorPago | formatPrice }}
    </template>

    <template v-slot:item.valorGlosado="{ item }">
      R$ {{ item.valorGlosado | formatPrice }}
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    arquivos: { type: Array, required: true }
  },
  data () {
    return {
      headers: [
        { value: 'nomeArquivo', text: 'Nome do arquivo', aling: 'start', class: 'font-weight-bold' },
        { value: 'valorInformado', text: 'Valor informado', align: 'start', class: 'font-weight-bold' },
        { value: 'valorProcessado', text: 'Valor processado', align: 'start', class: 'font-weight-bold' },
        { value: 'valorPago', text: 'Valor pago', align: 'start', class: 'font-weight-bold' },
        { value: 'valorGlosado', text: 'Valor glosado', align: 'start', class: 'font-weight-bold' },
        { value: 'quantidadeProtocolos', text: 'Quantidade protocolos', align: 'start', class: 'font-weight-bold' }
      ]
    }
  },
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument",
    })
  }
}
</script>
